export enum ModuleStatus {
  notStarted = 'not_started',
  inProgress = 'in_progress',
  requiredAnswered = 'required_answered',
  completed = 'completed',
}
